import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, PanInfo } from 'framer-motion';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
const slides = [{
  image: 'https://cdn.magicpatterns.com/uploads/9TnDoBHsvANtN9M6iMd7oB/slide_1.png',
  alt: 'Oferta de lanzamiento: Pack completo'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/dCDWeSdGr5JoRbNf4MPYFY/slide_2.png',
  alt: '¿Te pasa esto con tu dinero?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kE1QHMNuZDcmjmnzb42ysr/slide_3.png',
  alt: '¿Cómo podrías estar en 30 días?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/4797rN9cwSbovtUBL8a7jk/slide_4.png',
  alt: '¿Te pasa esto con tu dinero? - Pain points'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/1YwFAjRKGk1fJD9XVU8rdp/slide_5.png',
  alt: 'Pack Finanzas Fáciles para Mujeres'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gdikm3xgizpotsa6bVg6ML/slide_6.png',
  alt: 'Oferta especial de lanzamiento'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/oVWahPWxN9C7gz5NBuyynD/slide7.png',
  alt: 'Oferta de lanzamiento con pack visual'
}];
interface MobilePromoSlidesProps {
  onClose?: () => void;
}
export function MobilePromoSlides({
  onClose
}: MobilePromoSlidesProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  // Auto-advance slides
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      if (currentIndex < slides.length - 1) {
        handleNext();
      }
    }, 4000); // 4 seconds per slide
    return () => clearInterval(timer);
  }, [currentIndex, isPaused]);
  const handleNext = () => {
    if (currentIndex < slides.length - 1) {
      setDirection(1);
      setCurrentIndex(currentIndex + 1);
    }
  };
  const handlePrev = () => {
    if (currentIndex > 0) {
      setDirection(-1);
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleDragEnd = (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    const swipeThreshold = 50;
    if (info.offset.x > swipeThreshold) {
      handlePrev();
    } else if (info.offset.x < -swipeThreshold) {
      handleNext();
    }
  };
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  return <div className="fixed inset-0 bg-black z-50 md:hidden" data-id="element-406">
      {/* Progress bars */}
      <div className="absolute top-0 left-0 right-0 z-20 flex gap-1 p-2" data-id="element-407">
        {slides.map((_, index) => <div key={index} className="flex-1 h-1 bg-white/30 rounded-full overflow-hidden" data-id="element-408">
            <motion.div className="h-full bg-white" initial={{
          width: index < currentIndex ? '100%' : '0%'
        }} animate={{
          width: index === currentIndex ? '100%' : index < currentIndex ? '100%' : '0%'
        }} transition={{
          duration: index === currentIndex ? 4 : 0,
          ease: 'linear'
        }} data-id="element-409" />
          </div>)}
      </div>

      {/* Close button */}
      {onClose && <button onClick={onClose} className="absolute top-4 right-4 z-20 bg-black/50 text-white p-2 rounded-full backdrop-blur-sm" aria-label="Cerrar" data-id="element-410">
          <X className="w-5 h-5" data-id="element-411" />
        </button>}

      {/* Slides */}
      <div className="relative w-full h-full" data-id="element-412">
        <AnimatePresence initial={false} custom={direction} data-id="element-413">
          <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
          x: {
            type: 'spring',
            stiffness: 300,
            damping: 30
          },
          opacity: {
            duration: 0.2
          }
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.2} onDragEnd={handleDragEnd} className="absolute inset-0 flex items-center justify-center" onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)} data-id="element-414">
            <img src={slides[currentIndex].image} alt={slides[currentIndex].alt} className="w-full h-full object-contain" data-id="element-415" />
          </motion.div>
        </AnimatePresence>

        {/* Navigation tap areas */}
        <div className="absolute inset-0 flex z-10" data-id="element-416">
          <button onClick={handlePrev} disabled={currentIndex === 0} className="flex-1 focus:outline-none" aria-label="Anterior" data-id="element-417" />
          <button onClick={handleNext} disabled={currentIndex === slides.length - 1} className="flex-1 focus:outline-none" aria-label="Siguiente" data-id="element-418" />
        </div>
      </div>

      {/* CTA Button - appears on last slide */}
      {currentIndex === slides.length - 1 && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} className="absolute bottom-8 left-4 right-4 z-20" data-id="element-419">
          <a href="#oferta" onClick={onClose} className="block w-full bg-[#d4a574] hover:bg-[#c29463] text-[#1e3a5f] font-bold text-lg px-8 py-4 rounded-xl shadow-2xl text-center transition-all" data-id="element-420">
            Obtener el Pack Ahora
          </a>
        </motion.div>}

      {/* Slide counter */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 text-white text-sm font-medium bg-black/50 px-3 py-1 rounded-full backdrop-blur-sm" data-id="element-421">
        {currentIndex + 1} / {slides.length}
      </div>
    </div>;
}